export default __webpack_public_path__ + "static/media/ER14.14f9ce65.png";